export const LOADING = {
  SHOWLOADING: 'SHOWLOADING',
  HIDELOADING: 'HIDELOADING',
  RESOURCE: 'RESOURCE',
}

export const APP = {
  UPDATE_STATE: 'APP_UPDATE_STATE',
  LOG_OUT: 'APP_LOG_OUT',
  GET_USER_INFO: 'APP_GET_USER_INFO',
  GET_USER_RESOURCES: 'APP_GET_USER_RESOURCES',
  GET_WEATHER: 'APP_GET_WEATHER',
}

export const DATACENTER = {
  UPDATE_STATE: 'DATACENTER_UPDATE_STATE',
  GET_BASIC_INFO: 'DATACENTER_GET_BASIC_INFO',
  GET_MAP_INFO: 'DATACENTER_GET_MAP_INFO',
  GET_STATISTIC_INFO: 'DATACENTER_GET_STATISTIC_INFO',
  GET_ORDER_AND_BIKE_TREND: 'DATACENTER_GET_ORDER_AND_BIKE_TREND',
  GET_CITY_INFO: 'DATACENTER_GET_CITY_INFO',
  GET_BIKE_INFO: 'DATACENTER_GET_BIKE_INFO',
  GET_PARKING_POSITION: 'DATACENTER_GET_PARKING_POSITION',
  GET_OPERATION_POSITION: 'DATACENTER_GET_OPERATION_POSITION',
  GET_HEAT_MAP: 'DATACENTER_GET_HEAT_MAP',
  GET_LATEST_ORDER: 'DATACENTER_GET_LATEST_ORDER',
  GET_AREA_INFO: 'DATACENTER_GET_AREA_INFO',
  GET_PARKING_POINT_ALARM_LIST: 'DATACENTER_GET_PARKING_POINT_ALARM_LIST',
  GET_BIKE_LATEST_ORDER_LIST: 'DATACENTER_GET_BIKE_LATEST_ORDER_LIST',
  GET_USER_RESERVE_WORD_ORDER: 'DATACENTER_GET_USER_RESERVE_WORD_ORDER',
  GET_USER_FEEDBACK_WORD_ORDER: 'DATACENTER_GET_USER_RESERVE_WORD_ORDER',
  GET_EVENT_QUANTITY: 'DATACENTER_GET_EVENT_QUANTITY',
}

export const AUTHMANAGE = {
  UPDATE_STATE: 'AUTHMANAGE_UPDATE_STATE',
  GET_ROLE_LIST: 'AUTHMANAGE_GET_ROLE_LIST',
  GET_ROLE_INFO: 'AUTHMANAGE_GET_ROLE_INFO',
  ADD_ROLE: 'AUTHMANAGE_ADD_ROLE',
  UPDATE_ROLE: 'AUTHMANAGE_UPDATE_ROLE',
  UPDATE_ROLE_RESOURCE_BIND: 'AUTHMANAGE_UPDATE_ROLE_RESOURCE_BIND',
  GET_ENTITY_LIST: 'AUTHMANAGE_GET_ENTITY_LIST',
  GET_ALL_AREA: 'AUTHMANAGE_GET_ALL_AREA',
  GET_ENTITY_DETAIL: 'AUTHMANAGE_GET_ENTITY_DETAIL',
  GET_ENTITY_DEFAULT_RESOURCES: 'AUTHMANAGE_GET_ENTITY_DEFAULT_RESOURCES',
  ADD_ENTITY: 'AUTHMANAGE_ADD_ENTITY',
  REMOVE_ENTITY: 'AUTHMANAGE_REMOVE_ENTITY',
  UPDATE_ENTITY: 'AUTHMANAGE_UPDATE_ENTITY',
  GET_ALL_RESOURCES: 'AUTHMANAGE_GET_ALL_RESOURCES',
  UPDATE_ENTITY_RESOURCE_NAME: 'AUTHMANAGE_UPDATE_ENTITY_RESOURCE_NAME',
  UPDATE_ENTITY_REGISTER_COUNT: 'AUTHMANAGE_UPDATE_ENTITY_REGISTER_COUNT',
}

export const USERMANAGE = {
  // 列表页
  UPDATE_STATE: 'USERMANAGE_UPDATE_STATE',
  GET_ROLE_OPTONS_STATE: 'USERMANAGE_GET_ROLE_OPTONS_STATE',
  GET_AREA_OPTONS_STATE: 'USERMANAGE_GET_AREA_OPTONS_STATE',
  GET_ENTITY_OPTONS_STATE: 'USERMANAGE_GET_ENTITY_OPTONS_STATE',
  GET_USER_LISTS_STATE: 'USERMANAGE_GET_USER_LISTS_STATE',
  GET_SEARCH_ROLE_LIST: 'USERMANAGE_GET_SEARCH_ROLE_LIST',
}
